/* eslint-disable @typescript-eslint/ban-types */
import axios from 'axios';
import { getCreatorApiUrl } from '../components/api-urls';
import auth from '../components/auth';
import { SMap, TMap } from '../new/helpers/types';

type RangePayload = { rangeStart: string; rangeEnd: string };

export type DashboardQueryPayloadMap = {
  ConsumerFunnel: RangePayload;
  SubscriptionAnalytics: { influencerId: string };
  OTP: { influencerId: string };
  FreeOTP: { influencerId: string };
  OTPPaidAds: { influencerId: string };
  SubscriptionPaidAds: { influencerId: string };
};

export type MetabaseDashboards = keyof DashboardQueryPayloadMap;

const dashboardsQueryEndpointsMap: TMap<
  keyof DashboardQueryPayloadMap,
  string
> = {
  OTP: '/v4/otp',
  FreeOTP: '/free-otp',
  ConsumerFunnel: '/consumer-funnel',
  SubscriptionAnalytics: '/subscription-analytics',
  OTPPaidAds: '/ads/otp',
  SubscriptionPaidAds: '/ads/subscription',
};

export type MetabaseResult = { error?: string; url?: string };

const toSearchParams = (p: SMap<string>) => {
  if (Object.keys(p).length === 0) return '';
  return '?' + new URLSearchParams(p).toString();
};

export const getDashboardUrl = async <T extends keyof DashboardQueryPayloadMap>(
  name: T,
  {
    influencerId,
    ...p
  }: { influencerId: string } & DashboardQueryPayloadMap[T],
) => {
  const params = toSearchParams(p as SMap<string>);
  const endpoint = getCreatorApiUrl(
    `/metabase/${influencerId || 'null'}${
      dashboardsQueryEndpointsMap[name]
    }${params}`,
  );
  const headers = { Authorization: auth.getToken() };
  const res = await axios.get(endpoint, { headers });
  return res.data as MetabaseResult;
};
